import sanitizeHtml from "sanitize-html";
import sanitizeOptions from "../config/sanitize";

export default {
  install: Vue => {
    Vue.directive("click-outside", {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener("mousedown", el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.body.removeEventListener("mousedown", el.clickOutsideEvent);
      }
    });
    Vue.directive("html-sanitize", (el, binding) => {
      el.innerHTML = sanitizeHtml(binding.value, sanitizeOptions);
    });
  }
};
